import {
  allClubReactions,
  clubReactionDisplay,
  type ClubReactionKey,
} from "@/api/club/reactionKeys";
import { useTheme } from "@/theme/ThemeProvider";
import React from "react";
import { Pressable, Text, View } from "react-native";

type Props = {
  myReaction?: string | null;
  counts?: Array<{ reaction_key: string; count: number }>;
  disabled?: boolean;
  onSelect: (key: ClubReactionKey | null) => void;
};

/**
 * Sechs feste Reaktionen; Tap setzt/ändert, erneuter Tap auf eigene nimmt zurück.
 */
export function ReactionBar({
  myReaction,
  counts,
  disabled,
  onSelect,
}: Props) {
  const { theme } = useTheme();
  const countMap = Object.fromEntries(
    (counts ?? []).map((c) => [c.reaction_key, c.count])
  );

  return (
    <View
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 4,
      }}
    >
      {allClubReactions().map((r) => {
        const active = myReaction === r.key;
        const count = countMap[r.key] ?? 0;
        return (
          <Pressable
            key={r.key}
            disabled={disabled}
            onPress={() => onSelect(active ? null : r.key)}
            accessibilityRole="button"
            accessibilityLabel={`${r.label}${active ? ", ausgewählt" : ""}`}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 3,
              paddingHorizontal: theme.space.sm,
              paddingVertical: 2,
              borderRadius: theme.radius.sm,
              borderWidth: 1,
              borderColor: active
                ? theme.color.accentMuted
                : theme.color.border,
              backgroundColor: active
                ? theme.color.accentBg
                : theme.color.surface,
              opacity: disabled ? 0.5 : 1,
            }}
          >
            <Text style={{ fontSize: 12 }}>{r.emoji}</Text>
            <Text
              style={{
                color: active ? theme.color.primary : theme.color.muted,
                fontSize: theme.fontSize.tiny,
                fontWeight: active ? "700" : "500",
              }}
            >
              {r.label}
              {count > 0 ? ` ${count}` : ""}
            </Text>
          </Pressable>
        );
      })}
      {myReaction && !allClubReactions().some((r) => r.key === myReaction) ? (
        <Text
          style={{
            color: theme.color.muted,
            fontSize: theme.fontSize.tiny,
          }}
        >
          {clubReactionDisplay(myReaction).emoji}{" "}
          {clubReactionDisplay(myReaction).label}
        </Text>
      ) : null}
    </View>
  );
}
